export default function getHabits(habits) {
   let formattedHabits = new Array(7).fill("");

   habits.forEach(element => {

      const value = element.value.reduce((acc, item )=>{
         if(item && item.completed ){
            const link = `https://challenge.originnutrition.in${item.photo}`;

            return acc + (acc ? "\n" : "") + `${item.task}: ${link}`;
         }
         return acc;
      }, "")

      formattedHabits[element.day - 1] = value;      
   });
   

   return formattedHabits;
}